"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = require("@theme-ui/color");
var colors_1 = __importStar(require("./colors"));
var typography_1 = __importDefault(require("./typography"));
exports.default = {
    root: {
        background: colors_1.default.offBlack,
        color: colors_1.default.white,
        fontFamily: typography_1.default.fonts.body
    },
    h1: {
        variant: "text.h1"
    },
    h2: {
        variant: "text.h2",
    },
    h3: {
        variant: "text.h3",
    },
    h4: {
        variant: "text.h4",
    },
    h5: {
        variant: "text.h5",
    },
    li: {
        variant: "text.li",
    },
    p: {
        variant: "text.p",
    },
    a: {
        variant: "text.a",
    },
    small: {
        variant: "text.small",
    },
    hr: {
        color: color_1.alpha(colors_1.default.white, 0.06),
    },
    progress: {
        borderRadius: 1,
        background: colors_1.greys.grey900,
        color: colors_1.mainColors.primary,
        height: 1,
        mx: "auto",
        width: "200px",
        "::-webkit-progress-value": {
            borderRadius: 1
        },
        "::-webkit-progress-bar": {
            borderRadius: 1
        }
    }
};
